import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 6,
    },
    mutations: {
      retry: 6,
    },
  },
});
